var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#83878A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.056 599c1.105 0 2 .895 2 2v20c0 1.105-.895 2-2 2h-11c-1.104 0-2-.895-2-2v-3h2v1h11v-16h-11v1h-2v-3c0-1.105.896-2 2-2h11zm-13.35 8.037l6.858.007.006 6.858-1.829-.002-.003-3.729-6.435 6.436-1.303-1.303 6.435-6.435-3.727-.002-.002-1.83z",
    transform: "translate(-178 -599)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddA);
export default __webpack_public_path__ + "static/media/ic-add_a.98a31a1cb387a136dfc31889a025dba7.svg";
export { ForwardRef as ReactComponent };